/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@digital-hig/grid';
import Typography from '@digital-hig/typography';
import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import StoriesRootElement from './style';
import CardDetails from '../../../common/cardDetails/cardDetails';
import { isMobileDevice } from '../../../utils/srp.util';
import { ProfileContextConsumer } from '../../../common/context/profile/context';
import { FEATURED_SUCCESS_STORY_LENGTH } from '../../../constants/app-constants';
import ListingShimmer from '../../srp/Listing/listingShimmer';
import CardCarousel from '../../../common/cardDetails/cardCarousel';
import { getSuccessStoriesCardBaseURL } from '../../../utils/success-stories.util';

const FeaturedSuccessStories = ({ profileDetails, loading }) => {
  const { featureSuccessStories } = profileDetails || {};
  const { t } = useTranslation();
  const navigate = useNavigate();
  const param = useParams();

  const handleViewMore = async (item) => {
    if (item.display_name) {
      const baseUrl = getSuccessStoriesCardBaseURL(param.locale, { name: item.display_name, id: item.id });
      navigate(baseUrl);
    }
  };

  const getLink = (element) => getSuccessStoriesCardBaseURL(param.locale, { name: element.display_name, id: element.id });

  return (
    !!featureSuccessStories?.length
    && (
      <StoriesRootElement>
        <Box className="page-container">
          <Typography variant="headline-small" mb={6} component="h3">
            {t('Featured')}
            {param.locale !== 'jp' && (
              <>
                {' '}
                {t('Success stories').toLowerCase()}
              </>
            )}
          </Typography>
          {!isMobileDevice() && (
            <Grid className="grid-col">
              {!!featureSuccessStories?.length && featureSuccessStories.map((story, index) => (
                <CardDetails
                // eslint-disable-next-line react/no-array-index-key
                  key={`story-${index}`}
                  displayName={story.display_name}
                  headline={story.headline}
                  logo={story.logo_url}
                  link={getLink(story)}
                  localImg
                  view
                  handleViewMore={() => handleViewMore(story)}
                  dataWatVal="view"
                  dataWatLoc="featured stories"
                />
              ))}
              {loading && [...Array(FEATURED_SUCCESS_STORY_LENGTH).keys()].map((e) => (
                <ListingShimmer key={e} img />
              ))}
            </Grid>
          )}
          {isMobileDevice() && (
            <CardCarousel
              getLink={getLink}
              dataWatVal="view"
              dataWatLoc="featured stories"
              handleViewMore={handleViewMore}
              partners={featureSuccessStories}
              loading={loading}
              localImg
              view
            />
          )}
        </Box>
      </StoriesRootElement>
    )
  );
};

FeaturedSuccessStories.propTypes = {
  profileDetails: PropTypes.shape({}),
  loading: PropTypes.bool,
};
FeaturedSuccessStories.defaultProps = {
  profileDetails: {},
  loading: false,
};
export default ProfileContextConsumer(FeaturedSuccessStories);
